import CandidateStepFileUploadContainer from './candidate_step_file_upload_container';

const CandidateStepFileUpload = CandidateStepFileUploadContainer;
export default CandidateStepFileUpload;
